import ky from 'ky'
import { redirect } from 'next/navigation'

export const api = ky.create({
  prefixUrl: process.env.NEXT_PUBLIC_BFF_API,
  hooks: {
    afterResponse: [
      (_request, _options, response) => {
        const unauthorizedCode = 401
        if (response.status === unauthorizedCode) {
          redirect('/logout')
        }
      },
    ],
  },
})

export const apiAgendor = ky.create({
  prefixUrl: process.env.AGENDOR_URL,
  headers: {
    Authorization: `Token ${process.env.AGENDOR_KEY}`,
  },
})
